module.exports = __webpack_public_path__ + "static/media/golfer-4-a.fa542964.png";